__turbopack_context__.v({
  "className": "BS05pq_className",
});
